export default {
    meta: {
        title: '展位列表地图模式',
        isShowNav: true,
        activeMenu: '/booth',
        crumbs: {
            path: ['/booth'],
            name: ['展位管理'],
        },
    },
};
